import { ButtonProps } from "react-aria-components";
import { ReactNode, Ref } from "react";
import { MdsIconProps } from "@/design-system/components/icon/MdsIcon";

export enum MDSButtonVariant {
  Default = "default",
  Transparent = "transparent",
  Contrast = "contrast",
  Emphasis = "emphasis",
  EmphasisLight = "emphasis-light",
  Danger = "danger",
  DangerFilled = "danger-filled",
  OnAccent = "onAccent",
  Chrome = "chrome",
  Subtle = "subtle",
  ContrastAccent = "contrast-accent",
  Toggle = "toggle",
}

export enum MDSButtonSlotName {
  LeftIcon = "leftIcon",
  RightIcon = "rightIcon",
}

export enum MDSButtonLoadingIndicator {
  Overlay = "overlay",
  Icon = "icon",
}

export interface IMDSButtonProps extends Omit<ButtonProps, "children"> {
  ref?: Ref<HTMLButtonElement>;
  children?: ReactNode;
  variant?: MDSButtonVariant;
  isLoading?: boolean;
  isToggled?: boolean;
  loadingIndicator?: MDSButtonLoadingIndicator;
}

export interface IMDSButtonIconProps extends MdsIconProps {
  slot?: MDSButtonSlotName;
}
